import { notesApi } from "../services/notesApi";
import { totalApi } from "../services/totalApi";
import { ssTotalApi } from "../services/ssTotalApi";
import { itemPogSummaryApi } from "../services/itemPogSummaryApi";

const rootMiddleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({ serializableCheck: false }).concat([
    notesApi.middleware,
    totalApi.middleware,
    ssTotalApi.middleware,
    itemPogSummaryApi.middleware,
  ]);

export default rootMiddleware;
